import { toast } from 'sonner';

export function showValidationSummaryToast(message = 'Please complete highlighted required fields.') {
    toast.error(message);
}

